import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {OrderPriceSummaryWrapper, OrderPriceSummaryStyled, PriceSummaryItem} from './ConfirmationPage.style';
import Price from '../../components/Price/Price';
import {Em} from '../../components/Em/Em';
import {PROMOTION_TYPES} from '../../constants/constant';

class OrderPriceSummary extends PureComponent {
  render() {
    const {price, orderPromotions} = this.props;

    const renderAppliedPromotions = orderPromotions &&
      orderPromotions.map(promotion =>
        promotion.applied && (promotion.type === PROMOTION_TYPES.DISCOUNT || promotion.type === PROMOTION_TYPES.VOUCHER || promotion.type === PROMOTION_TYPES.SURCHARGE) &&
        <PriceSummaryItem
          data-rw="order-summary--savings-total"
          key={`${promotion.name}${promotion.amount}`}
        >
          <Em>
            <span>{promotion.name}</span>
          </Em>
          <Price amount={promotion.type === PROMOTION_TYPES.SURCHARGE ? promotion.amount: -promotion.amount} />
        </PriceSummaryItem>
      );
    const renderDeliveryFee = price.delivery > 0 && (
      <PriceSummaryItem data-rw="order-summary--delivery-total">
        <Em>
          <FormattedMessage id="confirmation.summary.delivery" />
        </Em>
        <Price amount={price.delivery} />
      </PriceSummaryItem>
    );

    const renderOrderAdminFee = price.orderFee > 0 && (
      <PriceSummaryItem data-rw="order-summary-admin-order-fee">
        <Em>
          <FormattedMessage id="confirmation.summary.orderAdminFee" />
        </Em>
        <Price amount={price.orderFee} />
      </PriceSummaryItem>
    );

    const renderTotalPrice = price.total > 0 && (
      <PriceSummaryItem data-rw="order-summary--total">
        <Em>
          <FormattedMessage id="confirmation.summary.total" />
        </Em>
        <Price amount={price.total} />
      </PriceSummaryItem>
    );

    return (
      <OrderPriceSummaryWrapper>
        <OrderPriceSummaryStyled>
          {renderDeliveryFee}
          {renderAppliedPromotions}
          {renderOrderAdminFee}
          {renderTotalPrice}
        </OrderPriceSummaryStyled>
      </OrderPriceSummaryWrapper>
    );
  }
}

OrderPriceSummary.propTypes = {
  price: PropTypes.object.isRequired,
  orderPromotions: PropTypes.array
};

export default OrderPriceSummary;



// WEBPACK FOOTER //
// ./containers/ConfirmationPage/OrderPriceSummary.js